import { render, staticRenderFns } from "./TableProviderCompany.vue?vue&type=template&id=3090af0b&scoped=true&"
import script from "./TableProviderCompany.vue?vue&type=script&lang=js&"
export * from "./TableProviderCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3090af0b",
  null
  
)

export default component.exports